import type { SearchFiltersState } from '@cinch-nx/data-search'
import { datadogRum } from '@datadog/browser-rum'
import Router from 'next/router'
import { StateCreator } from 'zustand'
import { mapFiltersToUrl } from '../../utils'

type URLMiddleware = <Store extends SearchFiltersState>(
  stateCreator: StateCreator<Store, [['zustand/devtools', never]]>,
  shouldUseDataDrivenSortOrderAsDefault: boolean,
  name?: string,
) => StateCreator<Store>

export const urlMiddleware: URLMiddleware =
  (stateCreator, shouldUseDataDrivenSortOrderAsDefault, name) =>
  (set, get, store) => {
    const updateUrlSet: typeof set = (...newState) => {
      set(...newState)
      // with the params we have make a url and change page url
      const state = get()

      const filtersToMap = {
        bodyType: state.bodyType,
        colour: state.colour,
        condition: state.condition,
        seats: state.seats,
        doors: state.doors,
        fromEngineSize: state.fromEngineSize,
        toEngineSize: state.toEngineSize,
        fuelType: state.fuelType,
        make: state.make,
        model: state.model,
        trim: state.trim,
        mileage: state.mileage,
        fromPrice: state.fromPrice,
        toPrice: state.toPrice,
        gearbox: state.gearbox,
        fromYear: state.fromYear,
        toYear: state.toYear,
        driveType: state.driveType,
        store: state.store,
        tags: state.tags,
        features: state.features,
        financeType: state.financeType,
        sortingCriteria: state.sortingCriteria,
        pageNumber: state.pageNumber,
        pageSize: state.pageSize,
        useMonthly: state.useMonthly,
        vehicleYear: state.vehicleYear,
        rangeInMiles: state.rangeInMiles,
      }

      const newPath = `/${mapFiltersToUrl(
        filtersToMap,
        state.allCinchStoresLowercase,
        undefined,
        shouldUseDataDrivenSortOrderAsDefault,
      )}`
      const currentUrlAsPath = Router.asPath
      // only navigate if the URL has actually changed
      if (currentUrlAsPath !== newPath) {
        Router.push(newPath, undefined, { shallow: true })
      }

      // not related to the URL, so if we add similar things here in the future, may want moving into a separate middleware
      datadogRum.setGlobalContextProperty('search-filters', filtersToMap)
    }
    store.setState = updateUrlSet

    return stateCreator(updateUrlSet, get, store)
  }
